import React from "react"
import Catg from "./Catg"
import ShopCart from "./ShopCart"
import "./style.css"

const Shop = ({ addToCart, shopItems }) => {
  return (
    <>
      <section className='shop background'>
       <div className="deals">
        <h2>Trending Deals</h2>
       </div>
       <div className="cards">
            <iframe src='https://inrdeals.com/embed/deals?user=sau531821803' width='100%' height='1140' frameborder='0' allowTransparency='true'> </iframe>
            </div>
      </section>
   
    </>
  )
}

export default Shop
